import React from 'react';
import { useTranslation } from 'react-i18next';

const SaveButton = ({ isSaveSuccessful, isSaving, handleSavingDesign }) => {
  const { t } = useTranslation();

  return (
    <div className="save-button-wrapper">
      <button
        id="save-button"
        className={`save-button ${isSaveSuccessful === true ? 'success' : ''} ${
          isSaveSuccessful === false ? 'error' : ''
        } ${isSaving ? 'loading' : ''}`}
        onClick={() => handleSavingDesign()}
        disabled={isSaveSuccessful !== null || isSaving}
      >
        <span>{t('save-button-component-save')}</span>

        <div className="loading-svg">
          <svg
            version="1.1"
            viewBox="0 0 50 50"
            style={{ enableBackground: 'new 0 0 50 50' }}
          >
            <circle
              cx="25"
              cy="25"
              r="17"
              fill="none"
              stroke="#999999"
              strokeWidth="5"
              strokeLinecap="round"
              strokeDasharray="80"
              strokeDashoffset="0"
            >
              <animateTransform
                attributeType="xml"
                attributeName="transform"
                type="rotate"
                from="0 25 25"
                to="360 25 25"
                dur="1s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="strokeDashoffset"
                values="80;40;0"
                dur="1s"
                repeatCount="indefinite"
              />
            </circle>
          </svg>
        </div>

        <div className="success-svg">
          <svg
            version="1.1"
            viewBox="0 0 29.756 29.756"
            style={{ enableBackground: 'new 0 0 29.756 29.756' }}
          >
            <path d="M29.049,5.009L28.19,4.151c-0.943-0.945-2.488-0.945-3.434,0L10.172,18.737l-5.175-5.173   c-0.943-0.944-2.489-0.944-3.432,0.001l-0.858,0.857c-0.943,0.944-0.943,2.489,0,3.433l7.744,7.752   c0.944,0.943,2.489,0.943,3.433,0L29.049,8.442C29.991,7.498,29.991,5.953,29.049,5.009z" />
          </svg>
        </div>

        <div className="unsuccess-svg">
          <svg
            fill="#000000"
            viewBox="0 0 32 32"
            style={{ enableBackground: 'new 0 0 32 32' }}
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path d="M18.8,16l5.5-5.5c0.8-0.8,0.8-2,0-2.8l0,0C24,7.3,23.5,7,23,7c-0.5,0-1,0.2-1.4,0.6L16,13.2l-5.5-5.5 c-0.8-0.8-2.1-0.8-2.8,0C7.3,8,7,8.5,7,9.1s0.2,1,0.6,1.4l5.5,5.5l-5.5,5.5C7.3,21.9,7,22.4,7,23c0,0.5,0.2,1,0.6,1.4 C8,24.8,8.5,25,9,25c0.5,0,1-0.2,1.4-0.6l5.5-5.5l5.5,5.5c0.8,0.8,2.1,0.8,2.8,0c0.8-0.8,0.8-2.1,0-2.8L18.8,16z"></path>{' '}
            </g>
          </svg>
        </div>
      </button>
    </div>
  );
};

export default SaveButton;
